// jshint module: true

import Component from './../../assets/scripts/component/component';
import findParentByClassName from './../../assets/scripts/modules/find-parent-by-classname';
import sleep from './../../assets/scripts/modules/sleep';
import easeOut from 'eases/quad-out';

const component = 'page';
const selector = `.${component}`;

const animateOutDelay = 150;
const animateInDelay = 50;
const scrollOffset = window.innerHeight * 3;
const staggeredTransitionDelay = 50;

let frameFancy;

let fancyTransform = function(element, index) {

  if (!element) {
    return;
  }

  element.style.willChange = 'transform';

  let top = element.getBoundingClientRect().top + 1;
  let distance = top - (window.innerHeight * 0.65); // Position where the effect stops in relation to viewport
  let maxDistance = window.innerHeight * 1.15;
  let multiplicationFactor = 0.1;
  let offset, easedDistance;

  distance = (distance > maxDistance) ? maxDistance : distance;
  distance = (distance < -maxDistance) ? -maxDistance : distance;
  distance = (distance < 0) ? 0 : distance;

  easedDistance = easeOut(distance / maxDistance) * 1000;
  easedDistance = distance < 0 ? -easedDistance : easedDistance;

  offset = (easedDistance * multiplicationFactor);
  offset = (offset < 0) ? 0 : offset; // No negative offset

  // Transform effect
  element.style.webkitTransform = `translate3d(0, ${offset}px, 0)`;
  element.style.transform = `translate3d(0, ${offset}px, 0)`;

  // Opacity effect test
  //const distanceOpacityZero = 50;
  //offset = (offset > distanceOpacityZero) ? distanceOpacityZero : offset;
  //const opacity = (distanceOpacityZero - offset) * (1 / distanceOpacityZero);
  //element.style.opacity = opacity;

};

class Page extends Component {

  constructor(name, element, options) {
    super(name, element, options);
  }

  init() {

    window.addEventListener('page-change', (event) => this.onPageChange(event), false);
    window.addEventListener('scroll', (event) => this.onWindowScroll(event), false);

    //window.setTimeout(() => {
    //  this.onWindowScroll.call();
    //}, 400); // TODO: Get rid of this dirty timeout. Doesn't initialize otherwise. Picture lazy loading perhaps?

  }

  async onPageChange(event) {

    if (this.element !== event.detail || this.element.classList.contains('is-target')) {
      return;
    }

    const pages = document.querySelectorAll(selector);

    for (const page of pages) {
      page.classList.remove('will-be-target');

      if (page.classList.contains('is-target')) {
        page.classList.remove('is-target');
        page.classList.add('animate-out');
        await sleep(animateOutDelay);
        page.classList.remove('animate-out');
      }
    }

    this.element.classList.add('animate-in');
    await sleep(animateInDelay);
    this.element.classList.remove('animate-in');
    this.element.classList.add('is-target');
    this.applyTitle();
    this.onWindowScroll();

  }

  applyTitle() {
    const page = document.querySelector(`${selector}.is-target`);
    const documentTitleElement = document.querySelector('title[data-title]');

    if (!page || !documentTitleElement) {
      return;
    }

    const documentTitle = documentTitleElement.getAttribute('data-title') || '';
    const pageTitle = page.getAttribute('data-title') || '';

    if (!pageTitle) {
      return;
    }

    document.title = `${pageTitle}${documentTitle}`;

  }

  onWindowScroll() {

    // iOS elastic scroll flickering fix
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream && window.pageYOffset < 0) {
      return;
    }

    const elements = document.querySelectorAll(`${selector}.is-target ${selector}__container > *`);

    if (!elements) {
      return;
    }

    window.cancelAnimationFrame(frameFancy);
    frameFancy = window.requestAnimationFrame(() => {

      [...elements].forEach((item, index) => fancyTransform(item, index));

    });

  }

}

for (const element of document.querySelectorAll(selector)) {
  element.instance = new Page(component, element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/page/page.js